import React, { useEffect, useState } from 'react'
import { Link, redirect, useNavigate } from 'react-router-dom';
import Footer from '../../Layout/Footer';
import Header from '../../Layout/Header';
import feedback from '../../../assets/img/notify.jpg';
import moment from 'moment';
import { browsetaskSearch, browsetaskSeller, getTaskCategoryList } from '../../../Redux/Task/action';
import { IMAGE_URL } from '../../../api';
import { Form } from 'react-bootstrap';
import { useFormik } from 'formik';
import { makeanOfferListFilter } from '../../../Redux/MakeanOffer/action';
import MultiRangeSlider from "multi-range-slider-react";
import loader from '../../../assets/img/loader.gif';

// import { Card } from 'react-bootstrap';
// import { BiTimeFive } from 'react-icons/bi';
// import { BsGlobe } from 'react-icons/bs';
// import { AiOutlineCalendar } from 'react-icons/ai';
// import { FaRupeeSign } from 'react-icons/fa';
// import taskimage from '../../assets/img/taskimg.png';
import * as Yup from 'yup';
import { date_range } from '../../functions';
import { FaRupeeSign } from 'react-icons/fa';
import Pagination from '../../Pagination';
import InfiniteScroll from 'react-infinite-scroll-component';

const BrowseTasks = () => {

    const [totalPageNumber, setTotalPageNumber] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [data, setData] = useState([]);
    const [browsesearch, setBrowseSearch] = useState('');
    const navigate = useNavigate();
    const [isloader, setIsloader] = useState(false);

    const __search = () => {
        setIsloader(true)

        const sort_order = formik.values.sort_order || localStorage.getItem('filter_sort_order') || "";
        const category = formik.values.category || localStorage.getItem('filter_category') || "";

        const filterprice_from = minValue || localStorage.getItem('filterprice_from') || 0;
        const filterprice_to = maxValue || localStorage.getItem('filterprice_to') || 0;


        browsetaskSearch(browsesearch, sort_order, category, minValue, maxValue)((response) => {
            if (response?.status && response?.data) {
                setIsloader(false)
                setData(response?.data?.data)
                localStorage.setItem('filter_sort_order', sort_order);
                localStorage.setItem('filter_category', category);
                localStorage.setItem('filterprice_from', filterprice_from);
                localStorage.setItem('filterprice_to', filterprice_to);
            }
        });
    }
    const handleSearch = () => {
        __search()
    }
    const __redirect = (task) => {
        if (task?.status[0]?.status == 1) {
            navigate('/makeanoffer', { state: { data: task } })
        }
        else {
            navigate('/')
        }
    }

    const [categories, setCategories] = useState();
    const [filterbydate, setFilterbyDate] = useState('All');
    const [tasks, setTasks] = useState([])
    const [minValue, set_minValue] = useState(localStorage.getItem('filterprice_from') ?? 0);
    const [maxValue, set_maxValue] = useState(localStorage.getItem('filterprice_to') ?? 0);
    const handleInput = (e) => {
        set_minValue(e.minValue);
        set_maxValue(e.maxValue);
    };
    useEffect(() => {
        handleSearch()
    }, [browsesearch]);

    const validationSchema = Yup.object().shape({

    });
    const formik = useFormik({
        initialValues: {
            filterdate_from: "",
            filterdate_to: "",
            minValue: "",
            maxValue: "",
            status_object: "",
            category: "",
            sort_order: "",
            sub_category: "",
            limit: "",

        },
        validationSchema,
        onSubmit: (values) => {
            // let formData = new FormData();
            // values.filterdate_from &&
            //     formData.append("filterdate_from", values.filterdate_from);
            // values.filterdate_to &&
            //     formData.append("filterdate_to", values.filterdate_to);
            // formData.append("filterprice_from", minValue);
            // formData.append("filterprice_to", maxValue);
            // formData.append("status_object", values.status_object);
            // formData.append("category", values.category);
            // formData.append("sort_order", values.sort_order);
            // formData.append("sub_category", values.sub_category);
            // formData.append("limit", values.limit);
            __search()
        },
    });
    const clearAll = () => {

        formik.setValues({
            filterdate_from: "",
            filterdate_to: "",
            minValue: "",
            maxValue: "",
            status_object: "",
            category: "",
            sort_order: "",
            sub_category: "",
            limit: "",
        });
        set_minValue(0);
        set_maxValue(20000);
        localStorage.removeItem('filter_category');
        localStorage.removeItem('filter_sort_order');
        localStorage.removeItem('filterprice_from');
        localStorage.removeItem('filterprice_to');
    }
    const handleSelectChange = (e) => {
        let from = "";
        let to = "";
        setFilterbyDate(e.target.value)
        if (e.target.value == "Today") {

            from = date_range("Today")[0]
            to = date_range("Today")[1]
        }
        else if (e.target.value == "Weekly") {

            from = date_range("Weekly")[0]
            to = date_range("Weekly")[1]
        }
        else if (e.target.value == "Monthly") {
            from = date_range("Monthly")[0]
            to = date_range("Monthly")[1]

        } else if (e.target.value == "All") {
            from = undefined
            to = undefined
        }
        formik.setValues({
            ...formik.values,
            filterdate_from: from,
            filterdate_to: to
        })
    }
    useEffect(() => {

        setFilterbyDate(localStorage.getItem('filter_date') || 'All')
        getTaskCategoryList()((response) => {
            if (response && response.status) {
                setCategories(response?.data?.data)
            }


        });

        // browsetaskSeller(currentPage, 10)((response) => {
        //     if (response?.status && response?.data) {
        //         setData(response?.data?.data)
        //         setTotalPageNumber(response?.data?.total_pages)
        //     }
        // });
    }, [])


    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);

    const paginate = () => {
        browsetaskSeller(page, 9)((response) => {
            if (response.status) {

                if ((data.length + response?.data?.data.length) >= response?.data?.count) {
                    setHasMore(false)
                }
                setData(data.concat(response?.data?.data))
            }
            else {
                setHasMore(false)
            }
        })
        setPage(page + 1)
    }
    return (
        <React.Fragment>
            <Header />
            <section>
                <div className="breadcrumbs">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 my-auto">
                                <h1>Browse Tasks </h1>
                                <ul className="trail-items">
                                    <li className="trail-item trail-begin">
                                        <Link to="/">
                                            <span itemProp="name">Home</span><i className="bi bi-chevron-double-right"></i>
                                        </Link>
                                    </li>
                                    <li className="trail-item trail-end">
                                        <span itemProp="item"><span itemProp="name"> Browse Tasks</span></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='logodesign-details'>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-4 col-lg-2 sidebar-filter">
                            <Form onSubmit={formik.handleSubmit}>
                                <div className='logodesign-details-filter mb-4'>
                                    <h3 className="mt-0 mb-3">Filters</h3>
                                    <h4 onClick={() => { clearAll() }} className="mt-0 mb-3" role="button">CLEAR ALL</h4>
                                </div>

                                <Form.Select value={formik.values.category || ""} aria-label="Default select example" className="mb-3" name='category' onChange={formik.handleChange}>
                                    <option value='' disabled hidden>Choose category</option>
                                    {categories?.map((category, index) =>
                                        <option key={index} value={category?.id}>{category?.name}</option>
                                    )}

                                </Form.Select>
                                <Form.Select value={formik.values.sort_order || ""} aria-label="Default select example" name='sort_order' onChange={formik.handleChange} className="mb-3">
                                    <option value='' disabled hidden>Sort by date</option>
                                    <option value="1" >Ascending </option>
                                    <option value="2">Descending</option>

                                </Form.Select>
                                {/* <Form.Select value={filterbydate} aria-label="Default select example" onChange={(e) => handleSelectChange(e)} className="mb-3">
                                    <option>Filter by</option>
                                    <option value="All" >All </option>
                                    <option value="Today">Daily</option>
                                    <option value="Weekly">Weekly</option>
                                    <option value="Monthly">Monthly</option>
                                    <option value="Period">Period</option>

                                </Form.Select> */}
                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                    <Form.Label>Price Range</Form.Label>
                                    <div className='range-value'>{minValue} <FaRupeeSign size={16} /> - {maxValue} <FaRupeeSign size={16} /></div>
                                    <MultiRangeSlider
                                        className='multi-price-ranger'
                                        min={0}
                                        max={20000}
                                        step={5}
                                        minValue={minValue}
                                        maxValue={maxValue}
                                        ruler={false}
                                        barInnerColor={"#012970"}
                                        onChange={(e) => {
                                            handleInput(e);
                                        }}
                                    />
                                </Form.Group>

                                <div className='filter-btn mt-4'>
                                    {isloader == true ?
                                        <div className='loader'>
                                            <img src={loader} alt="" className='img-fluid' />
                                        </div>
                                        :
                                        <button type="submit" className="btn btn-primary mb-4">Apply Filter</button>
                                    }
                                </div>


                            </Form>
                        </div>
                        <div className='col-lg-10 col-md-8'>
                            <section className='browse-tasks'>
                                <div className='container'>
                                    <div className='row'>
                                        <div className='col-lg-12'>
                                            <div className='browse-tasks-title'>
                                                <h3>Browse tasks</h3>
                                                <p>Check out what tasks people want done near you right now...</p>
                                            </div>
                                            <div className='col-lg-12'>
                                                <div className="search-form d-flex align-items-center justify-content-center">
                                                    <input type="text" name="query" placeholder="Search" title="Search" onChange={(e) => {
                                                        setBrowseSearch(e.target.value)
                                                    }} className='' />
                                                    <button type="submit" title="Search">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" className='search-icon searchlist-icon' fill="#fff" viewBox="0 0 16 16">
                                                            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                                                        </svg>
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="mytask-buyer section-bg p-0">
                                                <InfiniteScroll
                                                    dataLength={data.length}
                                                    next={paginate}
                                                    hasMore={hasMore}
                                                    loader={<p style={{ textAlign: 'center' }}>
                                                        <b>Loading...</b>
                                                    </p>}
                                                    endMessage={
                                                        <p style={{ textAlign: 'center' }}>
                                                            <b>Yay! You have seen it all</b>
                                                        </p>
                                                    }
                                                >
                                                    <div className="container">
                                                        <div className="row mt-4">
                                                            {data?.map((task, index) => (
                                                                <React.Fragment key={index}>

                                                                    {task?.status[0]?.status == 1 &&

                                                                        <React.Fragment>
                                                                            <div className="col-lg-6">
                                                                                <div className='' onClick={() => __redirect(task)}>
                                                                                    <div className="member">
                                                                                        <div className='col-lg-3'>
                                                                                            <div className="pic"><img src={IMAGE_URL + task?.image[0]?.image} className="img-fluid" alt="" /></div>
                                                                                        </div>
                                                                                        <div className='col-lg-7'>
                                                                                            <div className="member-info">
                                                                                                <div className='task_title_main'>
                                                                                                    <h4>{task?.title}</h4>
                                                                                                </div>
                                                                                                {task?.location == "" ?
                                                                                                    <></>
                                                                                                    :
                                                                                                    <p><i class="bi bi-geo-alt-fill me-2"></i> {task?.location}</p>
                                                                                                }
                                                                                                <p><i className="bi bi-calendar me-2"></i> {moment(task?.date_choice).format('ll')}</p>
                                                                                                <p><i className="bi bi-clock me-2"></i> {task?.time_slot == 1 ? "Before 10 AM" : task?.time_slot == 2 ? "10 AM - 2 PM" : task?.time_slot == 3 ? "2 PM - 6 PM" : task?.time_slot == 4 && "After 6 PM"}</p>
                                                                                                <div className='badge-w-set'>
                                                                                                    <span className="badge badge-light-success me-2">{task?.status[0]?.status == 1 ? "Open" : task?.status[0]?.status == 2 ? "Assigned" : task?.status[0]?.status == 3 && "Completed"}</span>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className='col-lg-2'>
                                                                                            <p className='mytask-price'><i class="bi bi-currency-rupee"></i> {task?.task_price}</p>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                        </React.Fragment>
                                                                    }
                                                                </React.Fragment>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </InfiniteScroll>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>


                    </div>
                </div>
            </section>
            {/* <Pagination setCurrentPage={setCurrentPage} total_pages={totalPageNumber} /> */}
            <Footer />
        </React.Fragment>
    )
}

export default BrowseTasks;